import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
export function FinalCTASection() {
  return <section id="precio" className="py-24 bg-gradient-to-br from-amber-400 via-yellow-400 to-emerald-400 relative overflow-hidden" data-id="element-1">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-3"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-5">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-2 drop-shadow-sm" data-id="element-6">
            La calma no es suerte.
          </h2>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-8 drop-shadow-sm" data-id="element-7">
            Es diseño.
          </h2>

          <p className="text-xl text-white/90 font-medium mb-12 max-w-2xl mx-auto" data-id="element-8">
            Si quieres cambiar el día a día (de verdad, no solo sentirte
            motivado/a por 10 minutos):
          </p>

          <div className="flex flex-col items-center gap-8 mb-12" data-id="element-9">
            <div className="relative group cursor-pointer" data-id="element-10">
              <div className="absolute -inset-4 bg-white/30 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-11"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qhpin6YT7a7eK1bRf1jjZb/rutinas_visuales_portada_de_ebook.png" alt="Portada del libro" className="w-48 md:w-56 rounded-lg shadow-2xl transform group-hover:scale-105 transition-transform duration-300 relative z-10" data-id="element-12" />
            </div>

            {/* Pricing block */}
            <div className="bg-white/20 backdrop-blur-sm border border-white/40 rounded-3xl px-10 py-8 text-center shadow-xl max-w-sm w-full" data-id="element-13">
              <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-2" data-id="element-14">
                Precio especial de lanzamiento
              </p>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-15">
                <span className="text-white/50 text-2xl font-bold line-through" data-id="element-16">
                  $29.900
                </span>
                <span className="bg-amber-400 text-white text-xs font-black px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-17">
                  -66%
                </span>
              </div>
              <div className="flex items-end justify-center gap-1 mb-6" data-id="element-18">
                <span className="text-white text-2xl font-bold mb-1" data-id="element-19">$</span>
                <span className="text-white text-7xl font-black leading-none tracking-tight" data-id="element-20">
                  9.900
                </span>
              </div>
              <button onClick={() => window.open('https://www.reconectarhoy.com/cart/47864918769899:1', '_blank')} className="w-full px-8 py-4 bg-white text-amber-600 text-xl font-extrabold rounded-full shadow-2xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 group" data-id="element-21">
                <Download className="w-6 h-6" data-id="element-22" />
                Descargar ahora
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-23" />
              </button>
            </div>

            <p className="text-white/90 font-medium text-lg" data-id="element-24">
              Empieza con una rutina. Un tablero. Un paso.
            </p>
          </div>

          <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full border border-white/30" data-id="element-25">
            <p className="text-white text-sm font-medium" data-id="element-26">
              📚 Ebook digital · Acceso inmediato · Plantillas imprimibles
              incluidas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}